import { render, staticRenderFns } from "./phone_button.vue?vue&type=template&id=0711e72a&scoped=true&"
import script from "./phone_button.vue?vue&type=script&lang=js&"
export * from "./phone_button.vue?vue&type=script&lang=js&"
import style0 from "./phone_button.vue?vue&type=style&index=0&id=0711e72a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0711e72a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})
